"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const app_1 = require("@obvio/app");
const react_toastify_1 = require("react-toastify");
exports.Container = (0, app_1.styled)(react_toastify_1.ToastContainer) `
  max-width: 40rem;
  width: 40vw;
  z-index: 1002;
  font-size: 0.875rem;
  > .Toastify__toast {
    white-space: pre-line;
    color: white;
    &.Toastify__toast--default {
      background: ${(theme) => theme.colors.gray.dark};
      color: white;
    }
    &.Toastify__toast--success {
      background: ${(theme) => theme.colors.success};
    }
    &.Toastify__toast--error {
      background: ${(theme) => theme.colors.error};
    }
    &.Toastify__toast--warning {
      background: ${(theme) => theme.colors.warning.light};
      color: ${(theme) => theme.colors.warning.dark};
      > button {
        color: ${(theme) => theme.colors.warning.dark};
      }
    }
    border-radius: 0.625rem;
    padding: 0;
    min-height: 3.125rem;
    padding: ${(theme) => `0.1rem ${theme.spacing.small}`};

    > button {
      align-self: auto;
      color: white;
      opacity: 1;
    }
  }
`;
